import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCarriers, carriersSelector } from '../reducers/carriersReducer';

function useCarriers() {
  const dispatch = useDispatch();
  const { carriers = [], isLoading, loaded, error } = useSelector((state) => carriersSelector(state));

  useEffect(() => {
    if (!loaded) {
      dispatch(getCarriers());
    }
  }, [loaded, dispatch]);

  return { carriers, isLoading, loaded, error };
}

export default useCarriers;
